// import React, { useState } from 'react';
import Image from '../assets/avatar.png';
import Resume from '../assets/Jasdev_Singh_Bedi_Resume_2026_Full_Stack_Developer.pdf';
import { TypeAnimation } from 'react-type-animation';
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';
import { BiSolidLocationPlus } from 'react-icons/bi';
// import { BiSolidPhone } from 'react-icons/bi';
import { FaGithub, FaLinkedin, FaWhatsapp, FaGraduationCap, FaEnvelope } from 'react-icons/fa';
// import { FaYoutube } from 'react-icons/fa';

function Banner() {
  // const [tooltipVisible, setTooltipVisible] = useState(false);

  // function copyText() {
  //   const textToCopy = document.getElementById('phoneNo').innerText;
  //   navigator.clipboard.writeText(textToCopy).then(() => {
  //     setTooltipVisible(true);
  //     setTimeout(() => setTooltipVisible(false), 2000); // Hide tooltip after 2 seconds
  //   });
  // }

  return (
    <div id='home' className='min-h-[85vh] lg:min-h-[78vh] flex items-center justify-around'>
      <div className="container mx-auto">
        <div className='flex gap-y-8 lg:items-center lg:gap-x-12 flex-col-reverse xl:flex-row'>

          <div className='flex-1 text-center font-secondary lg:text-left'>
            <motion.h1
              variants={fadeIn('up', 0.3)}
              initial="hidden"
              whileInView={'show'}
              viewport={{ once: true, amount: 0.7 }}
              className='text-[55px] font-bold leading-[0.8] lg:text-[110px] mb-3 lg:mb-0'>
              JASDEV <span>BEDI</span>
            </motion.h1>
            <motion.div
              variants={fadeIn('up', 0.4)}
              initial="hidden"
              whileInView={'show'}
              viewport={{ once: true, amount: 0.7 }}
              className='mb-6 text-[25px] lg:text-[50px] font-secondary font-semibold uppercese leading-[1] whitespace-nowrap'>
              <span className='mr-4 text-white'>I am a</span>
              <TypeAnimation sequence={[
                'Fullstack Developer', 2000,
                'UI/UX Designer', 2000,
                'Masters Graduate', 2000,
                'Lifelong Learner', 2000
              ]}
                speed={50}
                className='text-accent'
                wrapper='span'
                repeat={Infinity}
              />
            </motion.div>
            <motion.p
              variants={fadeIn('up', 0.5)}
              initial="hidden"
              whileInView={'show'}
              viewport={{ once: true, amount: 0.7 }}
              className='mb-0 lg:mb-8 max-w-lg mx-auto lg:mx-0'>
              <div className='flex flex-col lg:flex-row gap-x-6 lg:gap-y-4 mb-5 text-white text-lg items-center whitespace-nowrap'>

                <span className='flex items-center gap-2'><FaEnvelope />Jasdevbedi.aus@gmail.com</span>
                <span className='flex items-center gap-2'><FaGraduationCap />Queensland University of Technology</span>
                <span className='flex items-center gap-2'><BiSolidLocationPlus />Brisbane</span>
              </div>
              <div>

              </div>
            </motion.p>

            <motion.div
              variants={fadeIn('up', 0.6)}
              initial="hidden"
              whileInView={'show'}
              viewport={{ once: true, amount: 0.7 }}
              className='flex max-w-max gap-x-6 items-center mb-6 lg:mb-10 mx-auto lg:mx-0'>
              <a
                href={Resume}
                target="_blank"
                rel="noreferrer"
                className='btn btn_accent btn-sm lg:btn-lg flex items-center hover:animate-pulse whitespace-nowrap'>My Resume</a>
              <a
                href="tel:+61492917957"
                target="_blank"
                rel="noreferrer"
                className='btn btn_secondary btn-sm lg:btn-lg border-2 border-none bg-none text-white hover:bg-accent hover:text-white transition-all flex items-center hover:animate-pulse whitespace-nowrap ease-in-out duration-700'>
                Contact me
              </a>
              {/* <span className='flex items-center gap-2 relative' onClick={copyText}>
                <BiSolidPhone />
                <span id="phoneNo">+61492917957</span>
                {tooltipVisible && (
                  <span className='absolute bottom-0 top-7 transform -translate-x-4 bg-black text-green-500 text-sm p-1 rounded-full h-full px-5'>
                    Phone Number Copied!
                  </span>
                )}
              </span> */}
            </motion.div>

            <motion.div
              variants={fadeIn('up', 0.7)}
              initial="hidden"
              whileInView={'show'}
              viewport={{ once: true, amount: 0.7 }}
              className='flex text-[20px] gap-x-6 max-w-max mx-auto lg:mx-0'>
              {/* <motion.a
                variants={fadeIn('right', 0.3)}
                initial="hidden"
                whileInView={'show'}
                viewport={{ once: true, amount: 0.7 }}
                href="https://www.youtube.com/watch?v=AAobI96VheE" target='_blank' rel="noreferrer"
                className='hover:animate-pulse'>
                <FaYoutube />
              </motion.a> */}
              <motion.a
                variants={fadeIn('right', 0.3)}
                initial="hidden"
                whileInView={'show'}
                viewport={{ once: true, amount: 0.7 }}
                href="https://github.com/Devzio" target='_blank' rel="noreferrer"
                className='hover:animate-pulse'>
                <FaGithub />
              </motion.a>
              <motion.a
                variants={fadeIn('right', 0.5)}
                initial="hidden"
                whileInView={'show'}
                viewport={{ once: true, amount: 0.7 }}
                href="https://www.linkedin.com/in/jasdev-bedi/" target='_blank' rel="noreferrer"
                className='hover:animate-pulse'>
                <FaLinkedin />
              </motion.a>
              <motion.a
                variants={fadeIn('right', 0.6)}
                initial="hidden"
                whileInView={'show'}
                viewport={{ once: true, amount: 0.7 }}
                href="whatsapp://send?abid=+61492917957&text=Hello%2C%20Jasdev" target='_blank' rel="noreferrer"
                className='hover:animate-pulse'>
                <FaWhatsapp />
              </motion.a>
            </motion.div>
          </div>
          <motion.div
            variants={fadeIn('down', 0.7)}
            initial="hidden"
            whileInView={'show'}
            viewport={{ once: true, amount: 0.7 }}
            className='lg:flex flex-1 max-w-[220px] lg:max-w-[450px] mx-auto mt-[-80px] lg:mt-0'>
            <img src={Image} alt='Jasdev Bedi' className='avatar brightness-[90%] '></img>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default Banner;
